import { darkModeAware, withStyles } from '@glu/theming';
import {
  objectOf, oneOfType, string, number
} from 'prop-types';
import React from 'react';
import styles from './LengthIndicator.styles';

const LengthIndicator = ({ classes, maxLengthIndicatorLimit, value }) => (
  maxLengthIndicatorLimit ? (
    <p className={classes.root}>
      {value ? value.toString().length : 0}
      /
      {maxLengthIndicatorLimit}
    </p>
  ) : null);

LengthIndicator.propTypes = {
  classes: objectOf(string).isRequired,
  maxLengthIndicatorLimit: number,
  value: oneOfType([string, number])
};

LengthIndicator.defaultProps = {
  maxLengthIndicatorLimit: undefined,
  value: ''
};

export default darkModeAware(withStyles(styles)(LengthIndicator));
